import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "./ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const pad = (n) => String(n).padStart(2, "0");
const sel = "h-10 border border-neutral-600 bg-neutral-950 px-2 text-sm text-white";

// "Get our skin tips" email sign-up shown inside Journal articles.
export const SkinTipsSignup = ({ source }) => {
  const [email, setEmail] = useState("");
  const [month, setMonth] = useState("");
  const [day, setDay] = useState("");
  const [state, setState] = useState("idle");
  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      const birthday = month && day ? `${month}-${day}` : undefined;
      await axios.post(`${API}/subscribe`, { email, source, birthday });
      setState("done");
    } catch {
      setState("idle");
      toast.error("Please enter a valid email address.");
    }
  };
  return (
    <aside className="my-14 bg-neutral-950 px-6 py-10 text-center text-white md:px-12" data-testid="skin-tips-signup">
      <p className="text-[10px] uppercase tracking-[0.35em] text-neutral-400">The Lux Veritae Journal</p>
      <p className="font-vogue mt-3 text-3xl leading-tight">Get our skin tips</p>
      {state === "done" ? (
        <p className="mt-6 text-sm font-light text-neutral-200" data-testid="skin-tips-success">You're in. Watch your inbox for our newest guides, plus 10% off your first visit.</p>
      ) : (
        <>
          <p className="mx-auto mt-3 max-w-sm text-sm font-light text-neutral-300">Expert skin guides from our Scottsdale studio, 10% off your first visit, and 15% off during your birthday month.</p>
          <form onSubmit={submit} className="mx-auto mt-8 max-w-md">
            <div className="flex flex-col gap-3 sm:flex-row">
            <Input type="email" required autoComplete="email" placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-12 flex-1 rounded-none border-neutral-600 bg-transparent text-base text-white placeholder:text-neutral-400 focus-visible:ring-0" data-testid="skin-tips-email-input" />
            <button type="submit" disabled={state === "sending"} className="h-12 bg-white px-6 text-[11px] font-medium uppercase tracking-[0.2em] text-neutral-950 hover:bg-neutral-200 disabled:opacity-60" data-testid="skin-tips-submit-btn">{state === "sending" ? "Joining…" : "Sign Me Up"}</button>
            </div>
            <div className="mt-4 flex items-center justify-center gap-3 text-sm font-light text-neutral-300">
              <span>Birthday (optional) for a treat:</span>
              <select value={month} onChange={(e) => setMonth(e.target.value)} className={sel} aria-label="Birthday month" data-testid="skin-tips-birth-month">
                <option value="">Month</option>
                {MONTHS.map((m, i) => <option key={m} value={pad(i + 1)}>{m}</option>)}
              </select>
              <select value={day} onChange={(e) => setDay(e.target.value)} className={sel} aria-label="Birthday day" data-testid="skin-tips-birth-day">
                <option value="">Day</option>
                {Array.from({ length: 31 }, (_, i) => <option key={i} value={pad(i + 1)}>{i + 1}</option>)}
              </select>
            </div>
          </form>
          <p className="mt-4 text-[11px] font-light text-neutral-400">No spam. Unsubscribe anytime.</p>
        </>
      )}
    </aside>
  );
};
